import { combineReducers } from "redux";
import actionState from "./Common/ActionState";

import clientRequest from "./Common/ClientRequest";
import mainPage from "./Pages/MainPage";

const rootReducer = combineReducers({
    // Common
    ClientRequest: clientRequest,
    ActionState: actionState,
    // Pages
    MainPage: mainPage,
});

export default rootReducer;
